import { Outlet } from 'react-router-dom';

const CompanyReports = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default CompanyReports;
